import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(main)/layout.tsx")